import Homepage from './homepage';

const homepageConfig = {
  name: 'homepage',
  class: Homepage,
  querySelector: {},
  querySelectorAll: {},
  options: {},
};

export default homepageConfig;
